import { CartItem } from '../types'

/**
 * Formats a number as currency (USD)
 */
export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-TT', {
    style: 'currency',
    currency: 'TTD',
  }).format(amount)
}

/**
 * Calculates the total price for a cart item including customizations
 */
export const calculateItemTotal = (item: CartItem): number => {
  const basePrice = item.price
  const customizationPrice = item.customizations.reduce((total, customization) => {
    return total + customization.selectedOptions.reduce((sum, option) => sum + option.price, 0)
  }, 0)
  
  return Math.round((basePrice + customizationPrice) * item.quantity * 100) / 100
}

/**
 * Calculates the total price for all items in the cart
 */
export const calculateCartTotal = (items: CartItem[]): number => {
  const total = items.reduce((sum, item) => sum + item.totalPrice, 0)
  return Math.round(total * 100) / 100
}